import { Observable } from 'rxjs'
import { CurrentUser } from '../models/current-user'
import { AuthenticationResult } from '../models/authentication-result'
import { CurrentUserForESoa } from '../models/current-user-for-esoa'

export abstract class UserAccessGateway {
    abstract GetCurrentUserForESoa(): Observable<CurrentUserForESoa>
    abstract checkAuthorizationForRoute(route: string, planyear: number, isMfaValidated:any): Observable<AuthenticationResult>
    abstract checkSessionValid(): Observable<AuthenticationResult>
    abstract getOrgId(): Observable<string>
    // abstract getCurrentPlanYears(): Observable<number[]>
    abstract getCurrentPlanYears(): Observable<number[]>
    abstract getCurrentUser(): Observable<CurrentUser>
    abstract IsAllowtoAddUser(OrgId, userName): Observable<boolean>
    abstract IsAllowtoEditUser(username): Observable<boolean>
    abstract IsAllowtoEditAddOrg(username): Observable<boolean>
    abstract getcurrentPlanYearFromServer(): Observable<number>
    abstract LoadAdobeScript()
}
